export const minuteFormat = num => {
  if (!num) return '00:00'
  let hour = Math.floor(num / 60)
  let mimute = Math.floor(num - hour * 60)
  hour = hour < 10 ? '0' + hour : hour
  mimute = mimute < 10 ? '0' + mimute : mimute
  return hour + ':' + mimute
}
